import { humanize } from 'Main/Utils'

function CommonSelect ({
  label,
  value,
  disabled,
  options,
  onChange
}) {
  return (<>
      <span>{label}</span>
      <select
        disabled = {disabled}
        value={value}
        onChange={onChange}
      >
        <option value="">All</option>
        {(options || []).map((item) => (
          <option value={item.value} key={item.value}>{humanize(item.label)}</option>
        ))}
      </select>
  </>)
}

export default CommonSelect
